/* global FB, sgData, SGEvent, SGAction, jQuery */

(function ($) {
  /**
   * Default settings for the services.
   *
   * @type {Object}
   */
  var defaultOptions = {
    facebook: {
      loginEnabled: false,
      appId: null,
      advertisingId: null,
      language: 'en_US',
      userHasPassword: false,
    },
  };

  /**
   * External Services class.
   * @constructor
   */
  function XTServices() {
    this.services = {};
    var _this = this;

    /**
     * Initiates the external services.
     *
     * @param {Object} opts The services options.
     */
    this.init = function (opts) {
      var options = $.extend(true, {}, defaultOptions, opts);

      // Maybe convert facebook appId to integer type.
      if (options.facebook.appId) {
        options.facebook.appId = parseInt(options.facebook.appId, 10);
      }

      initFacebookServices(options.facebook);
    };

    /**
     * Initiates the Facebook Services.
     *
     * @param {Object} options The facebook options.
     */
    function initFacebookServices(options) {
      if (!options.loginEnabled) {
        return;
      }

      _this.services.facebook = new Facebook(options);

      // Facebook Login
      _this.services.facebookLogin = new FacebookLogin(_this.services.facebook);
    }
  }

  /**
   * Facebook class.
   * Initiates the Facebook SDK.
   *
   * @param {Object} options The options from services class.
   * @constructor
   */
  function Facebook(options) {
    var version = 'v2.6';
    var appId = options.appId;
    var language = options.language || 'en_US';
    var userHasPassword = options.userHasPassword;
    var urls = options.urls;

    /**
     * Initialises the Facebook SDK when it is loaded asynchronous.
     * @returns {void}
     */
    window.fbAsyncInit = function () {
      FB.init({
        appId: appId,
        cookie: true,
        xfbml: true,
        version: version,
      });
    };

    // Load the SDK.
    loadSDK();

    /**
     * Returns the ajax request url for the appropriate login type.
     * @param {string} type The login type.
     * @returns {string|null} The request url or null if type doesn't match.
     */
    this.getRequestUrl = function (type) {
      if (urls.hasOwnProperty(type)) {
        return urls[type];
      }
      return null;
    };

    /**
     * Returns true if the user has a password set
     * @returns {boolean} Info if the user has a password
     */
    this.getUserHasPassword = function () {
      return userHasPassword;
    };

    /**
     * Loads the Facebook JavaScript SDK.
     * @returns {void}
     */
    function loadSDK() {
      // Load SDK only for web.
      if (sgData.device.access === 'App') {
        return;
      }

      // Load the Facebook SDK.
      (function (d, s, id) {
        var js;
        var fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s);
        js.id = id;
        js.src = 'https://connect.facebook.net/' + language + '/sdk.js';
        fjs.parentNode.insertBefore(js, fjs);
      }(document, 'script', 'facebook-jssdk'));
    }
  }

  /**
   * Facebook Login class.
   *
   * @param {Facebook} facebook Instance of the Facebook Plugin
   * @constructor
   */
  function FacebookLogin(facebook) {
    enableButton();

    $(document).on('shopgateFramework.ui.contentUpdated', function () {
      enableButton();
    });

    // Append a click handler to the login button(s).
    $('.js-btn-merge-facebook')
      .off('click', handleMerge)
      .on('click', handleMerge);

    $('.js-btn-guest-login')
      .off('click', handleGuestLogin)
      .on('click', handleGuestLogin);

    var didSendCommand = false;
    var type;
    var password = null;
    var email = null;

    // Register to native event to handle the Facebook response.
    SGEvent.Broadcast.register('identityServiceDidLogIn');
    SGEvent.registerCallback('identityServiceDidLogIn', function (response) {
      if (!didSendCommand) {
        return;
      }

      if (response.success === true) {
        sendResponseToServer({
          accessToken: response.token,
        });
      }

      didSendCommand = false;
    });

    /**
     * Enables the Facebook Login button and appends the click handler.
     * @returns {void}
     */
    function enableButton() {
      var $loginButton = $('.js-btn-login-facebook');

      if (!$loginButton.length) {
        return;
      }

      var loginButtonType = $loginButton.data('type');

      if (loginButtonType === 'login' || facebook.getUserHasPassword()) {
        $loginButton
          .removeClass('disabled')
          .removeAttr('disabled');
      }

      // Append a click handler to the login button(s).
      $loginButton
        .off('click', handleLogin)
        .on('click', handleLogin);
    }

    /**
     * Handles the Facebook Login process.
     *
     * @param {Object} event The click event object.
     */
    function handleLogin(event) {
      event.preventDefault();

      // Check if FB object exists.
      if (sgData.device.access !== 'App' && typeof FB !== 'object') {
        console.error(new Error('Facebook SDK is not properly initiated!'));
        return;
      }

      determineType.apply(this);

      handleConnect();
    }

    /**
     * Handles the merging of shopgate account with facebook account.
     *
     * @param {Object} event The click event object.
     */
    function handleMerge(event) {
      event.preventDefault();

      if (sgData.device.access !== 'App' && typeof FB !== 'object') {
        console.error(new Error('Facebook SDK is not properly initiated!'));
        return;
      }

      determineType.apply(this);

      // Setting the password value;
      var $passwordfield = $('.js-password-merge-facebook');
      password = $passwordfield.val();

      // Setting the email value;
      var $emailfield = $('.js-email-merge-facebook');
      email = $emailfield.val();

      // For connecting with shopsystem account directly send request
      var sgConnect = $(this).data('sgConnect');
      if (sgConnect) {
        sendResponseToServer();
        return;
      }

      handleConnect();
    }

    /**
     * Send a data request to the server, indicating that the user wants to continue with a guest
     * checkout
     *
     * @param {Object} event The click event object.
     */
    function handleGuestLogin(event) {
      event.preventDefault();
      determineType.apply(this);

      var url = facebook.getRequestUrl(type);
      var requestData = { continueAsGuest: 1 };

      // Send all the information to the server.
      sendDataRequest(url, requestData);
    }

    /**
     * Determines the current action type based on
     * the buttons data-type attribute.
     * Needs the get the event handler context applied with .apply(this)
     * @returns {void}
     */
    function determineType() {
      var $button = $(this);
      type = $button.data('type');
    }

    /**
     * Handles the login process.
     * @returns {void}
     */
    function handleConnect() {
      if (sgData.device.access === 'App') {
        didSendCommand = true;
        SGAction.logInWithIdentityService({
          service: 'facebook',
          permissions: ['public_profile', 'email'],
        });
      } else {
        FB.login(function (response) {
          if (response.status === 'connected') {
            sendResponseToServer(response.authResponse);
          }
        }, { scope: 'public_profile, email' });
      }
    }

    /**
     * Sends the Facebook Login request result to the server.
     *
     * @param {Object} [responseParam] The facebook authResponse object.
     */
    function sendResponseToServer(responseParam) {
      var response = responseParam || {};

      var url = facebook.getRequestUrl(type);
      var requestData = {};

      if (!url) {
        console.error(new Error('No request url provided for login process with Facebook!'));
        return;
      }

      requestData.provider = 'facebook';
      requestData.type = type;

      if (type !== 'disconnect') {
        requestData.accessToken = response.accessToken || null;

        if (type === 'merge') {
          if (password !== null) {
            requestData.password = password;
          }

          if (email !== null) {
            requestData.email = email;
          }
        }
      }

      sendDataRequest(url, requestData);
    }

    /**
     * Sends a data-request to the server
     *
     * @param {string} url         Server endpoint to invoke
     * @param {Object} requestData Post data in JSON format
     */
    function sendDataRequest(url, requestData) {
      // Send all the information to the server.
      $.shopgate.ajax({
        url: url,
        type: 'POST',
        data: requestData,
        beforeSend: function () {
          $(document).trigger('shopgateFramework.waitingIndicator.show');
        },
        success: function (responseData) {
          // If the app provides a invalid token, run logout command
          // and try to logout again.
          if (!responseData.success && sgData.device.access === 'App') {
            SGAction.logOutFromIdentityService({ service: 'facebook' });
          }
        },
        error: function () {
          console.warn(arguments);
        },
      });
    }
  }

  window.xtServices = new XTServices();
})(jQuery);



// WEBPACK FOOTER //
// ./Library/1.0/common/xt-services.js